import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import Cookies from 'universal-cookie'

export const NoAuth = ({
	children
}: {
	children: JSX.Element
}): JSX.Element => {
	const location = useLocation()
	const cookies = new Cookies()
	const token = cookies.get('token')

	if (token) {
		return <Navigate to="/" state={{ from: location }} />
	}

	return children
}
